import { ActivityId, GAME_IDS } from '../../constants';
import { prettyPrintMsTime } from '../../util';


export const gameFilterOptions: Record<string, string> = {
  GAMEPLAY_FISHBALLBUSTER: GAME_IDS.GAMEPLAY_FISHBALLBUSTER,
  GAMEPLAY_OCTOGRAVITYBALLS: GAME_IDS.GAMEPLAY_OCTOGRAVITYBALLS,
  GAMEPLAY_SFISHBALLBUSTER: GAME_IDS.GAMEPLAY_SFISHBALLBUSTER,
  GAMEPLAY_SFISHGOBALLS: GAME_IDS.GAMEPLAY_SFISHGOBALLS,
  GAMEPLAY_BERZERKBALL: GAME_IDS.GAMEPLAY_BERZERKBALL,
  GAMEPLAY_SFISHSHORTSPAR: GAME_IDS.GAMEPLAY_SFISHSHORTSPAR,
};

type statTypeOptionsTypes = {
  activitySelectActive: boolean;
  name: (activityId: ActivityId | undefined) => string,
  tooltipLabel: (context: any) => string,
  xAxisLabel: string,
  yAxisLabel: string,
}

export const statTypeOptions: Record<string, statTypeOptionsTypes> = {
  dailyMaxScore: {
    activitySelectActive: true,
    name: (activityId) => `Daily Max Score ${activityId && GAME_IDS[activityId]}`,
    xAxisLabel: 'Date',
    yAxisLabel: 'Score',
    tooltipLabel: (context) => {
      return context?.raw;
    },
  },
  dailyPlayTime: {
    activitySelectActive: true,
    name: (activityId) => `Daily Play Time ${activityId && GAME_IDS[activityId]}`,
    xAxisLabel: 'Date',
    yAxisLabel: 'Play Time (s)',
    tooltipLabel: (context) => {
      const milliseconds = (context?.raw as number) * 1000;
      return prettyPrintMsTime(milliseconds);
    },
  },
  favoriteGame: {
    activitySelectActive: false,
    name: (activityId) => `Favorite Game ${activityId && GAME_IDS[activityId]}`,
    xAxisLabel: 'Game',
    yAxisLabel: 'Play Time (s)',
    tooltipLabel: (context) => {
      const milliseconds = (context?.raw as number) * 1000;
      return prettyPrintMsTime(milliseconds);
    },
  }
};
